import { IEquipment } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/Equipment.dto';
import { ICreditCondition } from '@r1-frontend/api-domru/payments/v1/credits/condition';

import { IProps as IOptionListProps } from '@r1-frontend/ui-react/components/OptionList';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { FullWidthListContainer, IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import AllPurchase from './AllPurchase';
import TestDrivePurchase from './TestDrivePurchase';
import { TConfirmParams } from './types';

import { PopupCustomStyles } from './styled';

interface IProps extends Pick<IOptionListProps, 'reverseVariants' | 'onClickOptionChip'> {
    isOpen: boolean,
    equipment: IEquipment,

    onConfirmSelect: (params: TConfirmParams) => void,
    onClose: () => void,

    isOnlyTestDrive?: boolean,
    creditConditions?: ICreditCondition[],
}

export const SelectPurchaseOptionPopup = ({ isOpen, onClose, isOnlyTestDrive = false, ...props }: IProps): JSX.Element | null => {
    if (isOnlyTestDrive && !props.equipment.testDrive) {
        return null;
    }

    return (
        <DefaultPopup
            isOpen={isOpen}
            justify={'center'}
            align={'center'}
            color={COLORS.BgSurface}
            customStyles={PopupCustomStyles}
            onClose={onClose}
        >
            <IndentContainer $desktop={[32]} $mobile={[24]}>
                <FullWidthListContainer $direction={'column'} $wrap={'nowrap'} $size={24}>
                    {isOnlyTestDrive
                        ? <TestDrivePurchase {...props}/>
                        : <AllPurchase {...props}/>
                    }
                </FullWidthListContainer>
            </IndentContainer>
        </DefaultPopup>
    );
};
